import { createAsyncActionType } from './index';

export const HOME_CONFIGURATION_GET = createAsyncActionType(
  'home',
  'HOME_CONFIGURATION_GET'
);

export const HOME_COURSE_LIST_GET = createAsyncActionType(
  'home',
  'HOME_COURSE_LIST_GET'
);

export const HOME_LAST_COURSES_GET = createAsyncActionType(
  'home',
  'HOME_LAST_COURSES_GET'
);

export const HOME_NEWS_LIST_GET = createAsyncActionType(
  'home',
  'HOME_NEWS_LIST_GET'
);

export const USEFUL_LINKS_GET = createAsyncActionType(
  'home',
  'USEFUL_LINKS_GET'
);
